import { Location } from './location';
export class AgentPremium {
}
export const AGENT_STATUS = {
    OUT: 'out',
    READY: 'ready',
    SERVICE_REQUESTED: 'service-requested',
    CHECK_IN: 'check-in',
    CHECK_OUT: 'check-out',
    CHECK_IN_START: 'check-in_registering_client_information',
    CHECK_IN_COMPLETED: 'check-in_transaction_completed',
    CHECK_OUT_START: 'check-out_registering_client_information',
    CHECK_OUT_COMPLETED: 'check-out_transaction_completed'
};
export class LocationAgent extends Location {
    constructor(lat, lng, positionDescription, timestamp) {
        super(lat, lng);
        this.positionDescription = positionDescription;
        this.date = timestamp;
    }
}
//# sourceMappingURL=agent-premium.js.map